export function not<T>(a: T[], b: T[]) {
  return a.filter(value => b.indexOf(value) === -1);
}
